<template>
  <div>
    <v-row>
      <v-col>
        <v-toolbar dense>
          <v-toolbar-title>
            <div class="text-left">
              <h3>Proposals</h3>
            </div>
          </v-toolbar-title>
          <v-btn
            v-if="!openedAddProposal"
            absolute
            dark
            bottom
            small
            right
            fab
            @click="addProposal"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-btn v-else absolute dark bottom small right fab @click="openedAddProposal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>

    <AddProposal v-if="openedAddProposal" />
    <ListProposals v-else />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AddProposal from "@/components/proposals/AddProposal";
import ListProposals from "@/components/proposals/ListProposals";
export default {
  name: "proposals",
  components: {
    AddProposal,
    ListProposals
  },
  data: () => ({ openedAddProposal: false }),
  created() {
    if (this.getClients.length == 0) this.loadAllClients();
    this.loadAllProposals();
  },
  computed: {
    ...mapGetters(["getClients"])
  },
  methods: {
    ...mapActions(["loadAllProposals", "loadAllClients"]),
    addProposal() {
      this.openedAddProposal = !this.openedAddProposal;
      console.log("add proposal!");
    }
  }
};
</script>
